// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N6ArL8oe9T7RwQC0eo_O {
	padding: 16px 20px 16px 20px;
	border-radius: 20px;
	box-shadow: 0 6px 10px -2px rgba(0, 0, 0, 0.07843);
	font-family: Cygnito Mono;
	font-size: 15px;
	font-weight: 400;
	line-height: 26px;
	letter-spacing: -0.08em;
	text-align: left;
	margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/PageDescription/PageDescription.pcss"],"names":[],"mappings":"AAAA;CACC,4BAA4B;CAC5B,mBAAmB;CACnB,kDAAkD;CAClD,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;AACpB","sourcesContent":[".description {\n\tpadding: 16px 20px 16px 20px;\n\tborder-radius: 20px;\n\tbox-shadow: 0 6px 10px -2px rgba(0, 0, 0, 0.07843);\n\tfont-family: Cygnito Mono;\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tline-height: 26px;\n\tletter-spacing: -0.08em;\n\ttext-align: left;\n\tmargin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `N6ArL8oe9T7RwQC0eo_O`
};
export default ___CSS_LOADER_EXPORT___;
